<template>
  <d-modal
    class="patients-form-ordinance"
    style="background-color: rgba(0,0,0,0.6)!important;">

    <button
      @click.prevent="onClosePopup"
      :class="['mr-1', 'decision-close-button', show ? 'decision-close-button-load' : 'decision-close-button-hidden']">
      <i class="material-icons">close</i>
    </button>

    <d-modal-header>
      <d-modal-title>
        <h3 class="page-title" v-if="!isEdited">Dodawanie zarządzenia</h3>
        <h3 class="page-title" v-else>Edycja zarządzenia</h3>
      </d-modal-title>
    </d-modal-header>

    <d-modal-body>
      <validation-observer
        ref="patients-form-ordinance"
        tag="form" >

        <label
          :for="'ordinance_number'"
          class="title-box">
          Podaj numer zarządzenia
        </label>
        <validation-provider
          rules="required"
          name="ordinance_number"
          v-slot="{ errors }">
          <d-input
            :type="'number'"
            :state="errors.length ? 'invalid' : null"
            v-model="data.number"
          />
          <div class="invalid-feedback">
            {{ errors[0] }}
          </div>
        </validation-provider>

        <label
          :for="'custom_name'"
          class="title-box">
          Imię i nazwisko wnioskującego(ej)
        </label>
        <validation-provider
          name="custom_name"
          v-slot="{ errors }">
          <d-input
            :type="'text'"
            v-model="data.customName" />
        </validation-provider>

        <label
          :for="'custom_patient_name'"
          class="title-box">
          Imię i nazwisko pacjenta
        </label>
        <validation-provider
          name="custom_patient_name"
          v-slot="{ errors }">
          <d-input
            :type="'text'"
            v-model="data.customPatientName" />
        </validation-provider>

        <div class="popup-box-buttons">
          <d-button
            theme="success"
            class="text-nowrap"
            @click.prevent="validateForm">
            Dodaj
          </d-button>
        </div>

      </validation-observer>
    </d-modal-body>

  </d-modal>
</template>

<script>
import FormUtils from '@/utils/FormUtils';

export default {
  name: 'PatientsFormOrdinancePopup',
  props: {
    patient: {
      default: null,
      type: Object
    },
    decision: {
      default: null,
      type: Object
    },
    onClosePopup: {
      default: () => {},
      type: Function
    },
    onSubmitCallback: {
      default: () => {},
      type: Function
    },
    isEdited: {
      default: false,
      type: Boolean
    },
    show: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      data: {
        number: '',
        customPatientName: '',
        customName: ''
      },
    };
  },
  mounted () {
    this.isEdited = this.decision.pdf_document_ordinance_id > 0;
    this.data.number = this.decision.ordinance_number;
    this.data.customName = (!this.isEdited) ? this.decision.guardian_name : this.decision.custom_name;
    this.data.customPatientName = (!this.isEdited) ? this.decision.patient_name : this.decision.custom_patient_name;
  },
  methods: {
    validateForm () {
      FormUtils.validate(this.$refs['patients-form-ordinance'], this.submitForm);
    },
    submitForm  () {
      let formDataToSend = {
        pdf_document_id: this.decision.id,
        number: this.data.number,
        custom_name: this.data.customName,
        custom_patient_name: this.data.customPatientName,
        pdf_document_ordinance_id: (this.isEdited) ? this.decision.pdf_document_ordinance_id : 0
      };
      let endpointUrl = (!this.isEdited) ? '/pdf-documents-ordinances/add-new' : '/pdf-documents-ordinances/edit/' + this.decision.pdf_document_ordinance_id;

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: (!this.isEdited) ? 'Dodano zarządzenie' : 'Zmieniono numer zarządzenia',
        successText: (!this.isEdited) ? 'Do orzeczenia dodano zarządzenia' : 'Numer zarządzenia został zmieniony',
        errorTitle: 'Wystąpił błąd',
        errorText: (!this.isEdited) ? 'Nie udało się dodać zarządzenia.' : 'Nie udało się edytować zarządzenia',
        successAction: () => {
          this.onSubmitCallback();
          this.onClosePopup();
        }
      });
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
@import '@/assets/scss/patients-form-ordinance.scss';
.patients-form-ordinance.is-hidden {
  display: none!important;
  pointer-events: none!important;
}
</style>
